'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Defines a serializer for numbers and bigints.
 * @category Serializers
 */

/**
 * Defines the options for u8 and i8 serializers.
 * @category Serializers
 */

/**
 * Defines the options for number serializers that use more than one byte.
 * @category Serializers
 */

/**
 * Defines the endianness of a number serializer.
 * @category Serializers
 */
exports.Endian = void 0;
(function (Endian) {
  Endian["Little"] = "le";
  Endian["Big"] = "be";
})(exports.Endian || (exports.Endian = {}));
//# sourceMappingURL=common.cjs.map
